<template>
  <div class="wall-posts-skeleton">
    <div v-for="i in count" :key="i" class="wall-post-skeleton-card">
      <!-- Header -->
      <div class="wall-post-skeleton-header">
        <div class="wall-post-skeleton-avatar"></div>
        <div class="wall-post-skeleton-user-info">
          <div class="wall-post-skeleton-name"></div>
          <div class="wall-post-skeleton-time"></div>
        </div>
      </div>

      <!-- Content -->
      <div class="wall-post-skeleton-content">
        <div class="wall-post-skeleton-text-line"></div>
        <div class="wall-post-skeleton-text-line"></div>
        <div class="wall-post-skeleton-text-line short"></div>
      </div>

      <!-- Actions -->
      <div class="wall-post-skeleton-actions">
        <div class="wall-post-skeleton-action-btn"></div>
        <div class="wall-post-skeleton-action-btn"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WallPostsSkeleton",
  props: {
    count: {
      type: Number,
      default: 3,
    },
  },
};
</script>

<style scoped>
.wall-posts-skeleton {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.wall-post-skeleton-card {
  background: #ffffff;
  border: 1px solid #e0dfdc;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

/* Header */
.wall-post-skeleton-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.wall-post-skeleton-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  flex-shrink: 0;
}

.wall-post-skeleton-user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wall-post-skeleton-name {
  width: 140px;
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.wall-post-skeleton-time {
  width: 80px;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

/* Content */
.wall-post-skeleton-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}

.wall-post-skeleton-text-line {
  width: 100%;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.wall-post-skeleton-text-line.short {
  width: 65%;
}

/* Actions */
.wall-post-skeleton-actions {
  display: flex;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.wall-post-skeleton-action-btn {
  width: 80px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

/* Shimmer Animation */
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .wall-post-skeleton-card {
    padding: 16px;
  }

  .wall-post-skeleton-avatar {
    width: 40px;
    height: 40px;
  }
}
</style>
